import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';
import {withLazyComponent} from './lazyComponent';
import {protectedRoute, signedInRoute} from './protectedRoute';
import {publicRoute} from './publicRoute';
import {useRecoilValue} from 'recoil';
import {globalAccountVerificationProfileState, globalBrandModuleSettingState, globalEWalletSettingState, globalInitLoadingState, globalUserVerifyState} from '../_common/global_state';
import Layouts from '../layouts';
import useShared from '../_common/_shared';
import AccountVerificationV2 from '../pages/accountVerificationV2/view';
import VoucherLoginRedirect from '../pages/voucher/view/loginRedirect';

const Page404 = withLazyComponent(React.lazy(() => import('../pages/_error/page404')));
const PageNotVerify = withLazyComponent(React.lazy(() => import('../pages/_error/pageNotVerify')));

const RouterComponent = () => {
  const userVerifyState = useRecoilValue(globalUserVerifyState);
  const initLoading = useRecoilValue(globalInitLoadingState);
  const brandWebModuleSetting = useRecoilValue(globalBrandModuleSettingState);
  const accountVerificationProfile = useRecoilValue(globalAccountVerificationProfileState);
  const eWalletSetting = useRecoilValue(globalEWalletSettingState);
  const {checkUserAccessRight} = useShared();

  // ewallet routes bypass the access-right check when the brand does not require KYC for them
  const kycRequired = {
    "ewallet-deposit": eWalletSetting?.depositWithKyc,
    "ewallet-withdrawal": eWalletSetting?.withdrawalWithKyc,
  };

  const isModuleEnabled = (item) => {
    const moduleSetting = brandWebModuleSetting?.find((module) => module?.name === item?.moduleName);
    return moduleSetting ? moduleSetting?.isEnabled : true;
  };

  return (
    <Routes>
      <Route key="home" path="/" element={<Layouts />}>
        {!initLoading && userVerifyState &&
          signedInRoute.map((item) => <Route key={item.path} path={item.path} element={<item.element />} />)}
        {initLoading ? null : userVerifyState && accountVerificationProfile?.accessRights ? (
          <>
            <Route index element={<Navigate to="/dashboard" replace />} />
            {protectedRoute &&
              protectedRoute.map((item, index) => {
                const moduleEnabled = isModuleEnabled(item);
                // const moduleEnabled = true;
                let routeElement = <item.element />;
                if (item?.id && !checkUserAccessRight(item?.id) && kycRequired[item?.id] !== false) {
                  routeElement = <PageNotVerify />;
                }

                return moduleEnabled ? <Route key={index} path={item?.path} element={routeElement} /> : null;
              })}
          </>
        ) : (
          <>
            <Route index element={<Navigate to="/login" replace />} />
            <Route key="dashboard" path="/dashboard" element={<PageNotVerify />} />
            <Route key="account-verification" path="/account-verification" element={<AccountVerificationV2 />} />
            <Route key="voucher-guard" path="/voucher" element={<VoucherLoginRedirect />} />
            {/* signed in but no verification profile yet: show the verification prompt, not a 404 */}
            {userVerifyState &&
              protectedRoute
                .filter((item) => !["/dashboard", "/account-verification", "/voucher"].includes(item?.path) && isModuleEnabled(item))
                .map((item) => <Route key={item.path} path={item.path} element={<PageNotVerify />} />)}
          </>
        )}
      </Route>
      {userVerifyState ? (
        <Route path="*" element={<Layouts />}>
          <Route path="*" element={<Page404 />} />
        </Route>
      ) : (
        <Route path="*" element={<Page404 />} />
      )}

      <Route path="/">
        {publicRoute &&
          publicRoute.map((item, index) => {
            return <Route key={index} path={item?.path} element={<item.element />} />;
          })}
      </Route>
    </Routes>
  );
};

export default RouterComponent;
